import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initBorderAnimated = (
    root = document,
    { exclude = null } = {}
) => {
    const borders = Array.from(root.querySelectorAll('[data-border-animated]'))

    borders.forEach((border) => {
        if (exclude && border.closest(exclude)) return
        const lines = Array.from(
            border.querySelectorAll('[data-border-animated-line]')
        )

        if (!lines.length) return

        const uninitialized = lines.filter(
            (line) => line.dataset.borderAnimatedInitialized !== 'true'
        )
        if (!uninitialized.length) return

        uninitialized.forEach((line) => {
            line.dataset.borderAnimatedInitialized = 'true'
        })

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            gsap.set(lines, { width: '100%' })
            return
        }

        gsap.set(lines, { width: 0 })

        ScrollTrigger.create({
            trigger: border,
            start: 'top 85%',

            once: true,
            onEnter: () => {
                gsap.to(lines, {
                    delay: 0.5,
                    width: '100%',
                    duration: 1,
                    ease: 'power3.out',
                    stagger: 0.3
                })
            }
        })
    })
}
